import React, { PureComponent } from 'react'
import {
  number, bool, string, arrayOf, shape,
} from 'prop-types'

import Accordion from '../../../../accordion/Accordion'
import PaymentMethodDetail from '../PaymentMethodDetail'
import PaymentMethodSummary from './PaymentMethodSummary'
import { paymentMethodPropType } from '../paymentMethodTypes'

import './PaymentMethodAccordion.scss'

class PaymentMethodAccordion extends PureComponent {
  static propTypes = {
    paymentMethod: paymentMethodPropType.isRequired,

    remittanceOptions: arrayOf(shape({
      countryCode: string.isRequired,
      currencyCode: string.isRequired,
      remittanceOptionSettingList: arrayOf(shape({
        fieldType: string.isRequired,
        fieldName: string.isRequired,
        required: bool,
        listIndex: number.isRequired,
      })),
    })),
  }

  static defaultProps = {
    remittanceOptions: [],
  }

  handleClick = () => {
    this.accordion.querySelector('.accordion__header-button').click()
  }

  render() {
    const { paymentMethod, ...rest } = this.props

    return (
      <div className="checkout-payments checkout__payment-accordion" ref={ref => { this.accordion = ref }}>
        <Accordion>
          <Accordion.Panel
            openIcon="ic-angle-down-bold"
            closeIcon="ic-angle-up-bold"
            transition="height 0.3s ease"
            paymentMethod={paymentMethod}
            title={(
              <div
                className="checkout__payment-accordion--header"
                onClick={this.handleClick}
                onKeyDown={this.handleClick}
              >
                <PaymentMethodSummary paymentMethod={paymentMethod} />
              </div>
)}
          >
            <PaymentMethodDetail paymentMethod={paymentMethod} {...rest} />
          </Accordion.Panel>
        </Accordion>
      </div>
    )
  }
}

export default PaymentMethodAccordion
